export default __webpack_public_path__ + "static/rsmc-8ed06e17011787434085ba7049db3a32.png";